import { initTrackableWidgets } from './init';
import { BrandhubBackground } from './brandhub_background';
import { Stage } from './stage';
import { CliplisterVideo } from './cliplister-video';
import { otto } from '@otto-ec/global-resources/nexus';
import { LotteryGame } from './lottery_game';
import { PictureTextGrid } from './picture_text_grid';
import { PictureTextSlider } from './picture_text_slider';

if (!otto.ft3.promo.staticcontent.isReady) {
    otto.ft3.promo.staticcontent.assignNamespace({
        brandhub_background: {
            init: () => {
                new BrandhubBackground();
            },
        },
        stage: {
            init: () => {
                new Stage();
            },
        },
        link: {
            init: () => {
                initTrackableWidgets();
            },
        },
        picture_info_card: {
            init: () => {
                initTrackableWidgets();
            },
        },
        video: {
            init: () => {
                initTrackableWidgets();
                new CliplisterVideo();
            },
        },
        lottery_game: {
            init: () => {
                const lotteryGame = new LotteryGame();
                lotteryGame.init();
            },
        },
        picture_text_slider: {
            init: () => {
                new PictureTextSlider();
            },
        },
        picture_text_grid: {
            init: () => {
                new PictureTextGrid();
            },
        },
    });
}
